import sha256 from 'crypto-js/sha256.js';
import Base64 from 'crypto-js/enc-base64.js';
import config from '@/config';

const isInThePast = (epochMillis: number): boolean => {
  if (!epochMillis) {
    return true;
  }
  const nowMillis = new Date().getTime();
  return nowMillis > epochMillis;
};

const tokenExists = (): boolean => {
  const tokenExpiryDate = localStorage.getItem('autoLogoutTime');
  const token = localStorage.getItem('pnAccessToken');
  return !!token && !!tokenExpiryDate;
};

const tokenHasExpired = (): boolean => {
  const tokenExpiryDate = localStorage.getItem('autoLogoutTime');
  const tokenExpiryMillis = Date.parse(tokenExpiryDate ?? '');
  return isInThePast(tokenExpiryMillis);
};

const refreshToken = () => {
  const language = localStorage.getItem('language');
  const loginPath = `/${language}/login`;

  const redirectPath = `${window.location.pathname}`;
  console.log(`redirect path ${redirectPath}`);
  if (loginPath !== redirectPath) {
    window.location.replace(
      `${window.location.origin}${loginPath}?redirect=${encodeURIComponent(redirectPath)}`
    );
  } else {
    window.location.replace(window.location.origin + loginPath);
  }
};

const generateRandomString = (
  length: number,
  possible = config.VUE_APP_GENERATE_STRING
): string => {
  const arr = new Uint32Array(length);
  window.crypto.getRandomValues(arr);
  let text = '';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(arr[i] % possible.length);
  }
  return text;
};
const generateCodeChallenge = (codeVerifier: string): string => {
  const hashDigest = sha256(codeVerifier);
  return Base64.stringify(hashDigest).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};

const generateCodeVerifier = (): string => {
  return generateRandomString(128);
};

const forceAuthHeaders = async () => {
  if (tokenExists() && tokenHasExpired()) {
    refreshToken();
  }

  const token = localStorage.getItem('pnAccessToken');
  if (!token) {
    throw new Error('missing auth token while calling auth endpoint');
  }
  return {
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json; charset=UTF-8',
  };
};

const toYMD = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const isWeekend = (date: Date): boolean => {
  const day = date.getDay();
  return day === 0 || day === 6;
};

const getOrdinalSuffix = (day: number): string => {
  if (day >= 11 && day <= 13) {
    return 'th';
  }

  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const formatDateWithOrdinal = (dateYmd: string): string => {
  const date = new Date(`${dateYmd}T00:00:00`);
  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'long' });
  return `${day}${getOrdinalSuffix(day)} ${month}`;
};

export {
  tokenExists,
  tokenHasExpired,
  generateCodeChallenge,
  generateCodeVerifier,
  forceAuthHeaders,
  toYMD,
  isWeekend,
  getOrdinalSuffix,
  formatDateWithOrdinal,
};
